export const Types = {
    "안정형" : "안정형",
    "회피형" : "회피형",
    "감독형" : "감독형",
    "자책형" : "자책형",
} 
const QuestionList = [
    {
        sent : "주변 사람들이 맡은 바 최선을 다했으면 좋겠다.",
        type : Types["감독형"],
    },
    {
        sent : "일을 할 때 완벽하게 해내지 못해 시작을 미룬다.",
        type : Types["회피형"],
    },
    {
        sent : "실수나 실패를 하면 사람들은 나에게 실망할 것이다.",
        type : Types["자책형"],
    },
    {
        sent : "나는 스스로 다소 높은 기준을 세우더라도, 실천하는 과정에서 성취감(만족감)을 느낀다.",
        type : Types["안정형"],
    },
    {
        sent : "내 주위사람들에 대해 상당히 높은 기준을 가지고 있다.",
        type : Types["감독형"],
    },
    {
        sent : "일을 미루면서도 쉬지 못하고 늘 마음이 불편하다.",
        type : Types["회피형"],
    },
    {
        sent : "사람들을 만나면 그들의 표정, 반응 등을 자주 신경쓴다.",
        type : Types["자책형"],
    },
    {
        sent : "다른 사람들의 인정이나 부정적인 평가에 신경쓰지 않는다.",
        type : Types["안정형"],
    },
    {
        sent : "내 주변 사람들이 최선을 다하지 않는 것을 보면 답답하거나 화가 난다.",
        type : Types["감독형"],
    },
    {
        sent : "내가 어떤 일을 확실하게 잘해낼 확신이 없을 때는 시도를 피한다.",
        type : Types["회피형"],
    },
    {
        sent : "다른 사람들과 비교를 자주하며 스트레스를 받는 편이다.",
        type : Types["자책형"],
    },
    {
        sent : "나의 기준은 내가 정하고 판단한다.",
        type : Types["안정형"],
    },
    {
        sent : "내 주변 사람들이 어떤 일이든 나만큼만 하면 좋겠다.",
        type : Types["감독형"],
    },
    {
        sent : "주변에서는 나를 태평하다고 하지만, 나는 성과에 대해 두렵고 불안하다.",
        type : Types["회피형"],
    },
    {
        sent : "내가 실수를 하면 주변 사람들이 나를 형편없다고 생각할 것이다.",
        type : Types["자책형"],
    },
    {
        sent : "나는 실패를 통해 배우고 성장한다.",
        type : Types["안정형"],
    },    {
        sent : "나는 스스로 성장하려고 노력하지 않는 사람들을 보면 참을 수 없다.",
        type : Types["감독형"],
    },
    {
        sent : "나는 확실하게 못할 바에야 하지 않는 것이 낫다고 생각한다.",
        type : Types["회피형"],
    },
    {
        sent : "나는 장점보다 단점이 많은 사람이다.",
        type : Types["자책형"],
    },
    {
        sent : "결과보다는 과정의 성취감을 중요시 한다.",
        type : Types["안정형"],
    },
]

export default QuestionList;